import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=b6f8a32c&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6f8a32c')) {
      api.createRecord('b6f8a32c', component.options)
    } else {
      api.reload('b6f8a32c', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=b6f8a32c&", function () {
      api.rerender('b6f8a32c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bANi4mp1Z0f0/JS/comp/IncreaseNumber.vue"
export default component.exports